var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33561",
    "data-name": "Group 33561",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#ffebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24202",
    "data-name": "Group 24202",
    transform: "translate(1590.999 111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M225.519,395.468s-.474,8.5-.749,10.972a1.953,1.953,0,0,1-2.058,1.9c-2.277.041-4.557.044-6.833,0a1.932,1.932,0,0,1-2-1.887c-.277-2.5-.748-10.978-.748-10.978",
    transform: "translate(-211.925 -392.224)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M226.55,395.24h-14.8",
    transform: "translate(-211.749 -392.195)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M224.115,394.8a1.438,1.438,0,0,1-1.409-1.156l-.212-1.061a1.117,1.117,0,0,0-1.08-.828h-3.694a1.117,1.117,0,0,0-1.08.828l-.212,1.061a1.438,1.438,0,0,1-1.41,1.156",
    transform: "translate(-212.165 -391.751)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24203",
    "data-name": "Group 24203",
    transform: "translate(5.655 6.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24204",
    "data-name": "Group 24204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M0,0H6.109",
    transform: "rotate(90)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M0,0H6.109",
    transform: "translate(3.491) rotate(90)",
    fill: "none",
    stroke: "#ff4747",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleted);
export default __webpack_public_path__ + "static/media/IconDeleted.b9319e1e77a0e2eda5b172afeacd7609.svg";
export { ForwardRef as ReactComponent };